<li class='film-item' data-id={{id}}>
  <img class='main-image' loading='lazy' src='{{src}}' alt='{{name}}' />
  <div class='tex-item'>
    <p class='item-name'>{{name}}</p>
    <div class='info'>
      <p class='item-genre'>{{genr}}</p>
      <p class='item-year'>{{year}}<span class='vote'>{{vote}}</span></p>
    </div>
  </div>
</li>